
import homeFloatingNavigation from "./home/index.js";
import homeHeroVideo from "./home/_hero.js";
import ColumnDetail from "./column/_detail.js";
import rich from "./rich/index.js";
import staff from "./staff/_detail.js";
import voiceSlider from "./home/_voice.js";
import accessSlider from "./home/_access.js";
import searchArea from "./search/area.js";
import searchStation from "./search/station.js";
import searchSchool from "./search/school.js";
import SearchMap from "./search/map/index.js";
import estateIndex from "./estate/index.js";
import estateDetail from "./estate/detail.js";
import error from "./error/index.js";
import companyHistory from "./company/_index.js";
import flowAccordion from "./flow/_index.js";
import memberMerit from "./member-merit/index.js";
import sellconsultationModalForm from "./sellconsultation/index.js";
import recruitBgVideo from "./recruit/_bg_video.js";
import recruitInterviewSlider from "./recruit/_interview_slider.js";
import recruitInterviewModal from "./recruit/_interview_modal.js";
import recruitFloating from "./recruit/_floating.js";
import recruitDataCount from "./recruit/_data_count.js";
const pages = () => {
    homeFloatingNavigation();
    homeHeroVideo();
    ColumnDetail();
    rich();
    staff();
    voiceSlider();
    accessSlider();
    searchArea();
    searchStation();
    searchSchool();
    SearchMap();
    estateIndex();
    estateDetail();
    error();
    companyHistory();
    flowAccordion();
    memberMerit();
    sellconsultationModalForm();
    recruitBgVideo();
    recruitInterviewSlider();
    recruitInterviewModal();
    recruitFloating();
    recruitDataCount();
};
export default pages;
